import EquipmentsListItems from "./equipmentsListItems";

export default EquipmentsListItems;
